import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="reveal-password"
export default class extends Controller {
  static targets = [
    'passwordInput',
    'eyeIcon',
    'eyeSlashIcon',
  ]

  declare readonly passwordInputTarget: HTMLInputElement
  declare readonly eyeIconTarget: HTMLElement
  declare readonly eyeSlashIconTarget: HTMLElement

  toggleReveal (): void {
    if (this.passwordInputTarget.type === 'password') {
      this.passwordInputTarget.type = 'text'
      this.eyeIconTarget.classList.add('hidden')
      this.eyeSlashIconTarget.classList.remove('hidden')
    } else if (this.passwordInputTarget.type === 'text') {
      this.passwordInputTarget.type = 'password'
      this.eyeSlashIconTarget.classList.add('hidden')
      this.eyeIconTarget.classList.remove('hidden')
    }
  }
}
